import React from 'react'
import * as S from './styles'
import { ModalContentProps } from './types'

export function ModalContent({ children, ...props }: ModalContentProps) {
  return <S.Wrapper {...props}>{children}</S.Wrapper>
}
